import React, { useEffect, useState } from "react";
import { Menu, X, ArrowRight } from "lucide-react";
import { NAV_LINKS, BRAND } from "../mock";

const Mark = ({ tone = "lime" }) => (
  <span
    className={`grid place-items-center w-8 h-8 rounded-[10px] font-bold text-[17px] leading-none ${
      tone === "lime" ? "bg-[#d8ff00] text-[#0e0e0d]" : "bg-[#0e0e0d] text-[#d8ff00]"
    }`}
  >
    s
  </span>
);

export default function Navbar() {
  const [phase, setPhase] = useState("hidden");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const vh = window.innerHeight || 800;
      const y = window.scrollY;
      if (y < vh * 0.5) {
        setPhase("hidden");
        return;
      }
      const hero = document.getElementById("top");
      const lime = document.getElementById("lime");
      if (hero && hero.getBoundingClientRect().bottom > 76) setPhase("video");
      else if (lime) {
        const r = lime.getBoundingClientRect();
        setPhase(r.top <= 76 && r.bottom > 76 ? "lime" : "solid");
      } else setPhase("solid");
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const onLight = phase === "solid" || phase === "lime";
  const glass = phase === "solid";
  const hidden = phase === "hidden" && !open;

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        hidden ? "-translate-y-full opacity-0 pointer-events-none" : "translate-y-0 opacity-100"
      } ${
        glass
          ? "bg-white/85 backdrop-blur-xl border-b border-black/[0.07]"
          : phase === "lime"
          ? "bg-[#d8ff00]/80 backdrop-blur-md"
          : "bg-transparent"
      }`}
    >
      <nav className="container-x flex items-center justify-between h-[72px]">
        <button
          onClick={() => go("#top")}
          data-testid="nav-logo"
          className="flex items-center gap-2.5 group"
          aria-label={BRAND.name}
        >
          <Mark tone={onLight ? "ink" : "lime"} />
          <span
            className={`text-[21px] font-semibold tracking-[-0.03em] transition-colors ${
              onLight ? "text-[#0e0e0d]" : "text-white"
            }`}
          >
            {BRAND.name}
          </span>
        </button>

        <div
          className={`hidden lg:flex items-center gap-1 rounded-full px-1.5 py-1.5 backdrop-blur-xl border transition-colors ${
            onLight ? "bg-black/[0.04] border-black/[0.06]" : "bg-white/10 border-white/15"
          }`}
        >
          {NAV_LINKS.map((l) => (
            <button
              key={l.href}
              onClick={() => go(l.href)}
              data-testid={`nav-link-${l.href.replace("#", "")}`}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                onLight ? "text-[#3d3d38] hover:bg-white" : "text-white/85 hover:bg-white/15 hover:text-white"
              }`}
            >
              {l.label}
            </button>
          ))}
        </div>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href={`#faq`}
            onClick={(e) => {
              e.preventDefault();
              go("#faq");
            }}
            data-testid="nav-faq"
            className={`text-sm font-medium transition-colors ${
              onLight ? "text-[#3d3d38] hover:text-[#0e0e0d]" : "text-white/80 hover:text-white"
            }`}
          >
            Časté dotazy
          </a>
          <button
            onClick={() => go("#kontakt")}
            data-testid="nav-cta"
            className={`px-5 py-2.5 text-sm ${phase === "lime" ? "btn-ink" : "btn-lime"}`}
          >
            Chci nový web
          </button>
        </div>

        <button
          className={`lg:hidden ${onLight ? "text-[#0e0e0d]" : "text-white"}`}
          onClick={() => setOpen((v) => !v)}
          data-testid="nav-mobile-toggle"
          aria-label="menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </nav>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="lg:hidden bg-[#0e0e0d] border-t border-white/10 px-6 py-7 flex flex-col gap-5"
        >
          {NAV_LINKS.map((l) => (
            <button
              key={l.href}
              onClick={() => go(l.href)}
              data-testid={`nav-mobile-link-${l.href.replace("#", "")}`}
              className="text-left text-xl text-white/85 hover:text-white display"
            >
              {l.label}
            </button>
          ))}
          <button onClick={() => go("#kontakt")} data-testid="nav-mobile-cta" className="btn-lime px-5 py-3.5 mt-2">
            Chci nový web <ArrowRight size={17} />
          </button>
        </div>
      )}
    </header>
  );
}
